import DashboardProspecting from "./DashboardProspecting";
export default DashboardProspecting;
